// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EVENTS_NAME = [
  "signup_started",
  "login_screen_viewed",
  "login_attempt",
  "login_success",
  "login_failure",
  "forgot_password_clicked",
  "sign_up_button_clicked",
  "password_reset_initiated",
  "password_reset_success",
  "password_reset_failure",
  "account_locked",
  "verification_email_sent",
  "account_verification_completed",
  "sign_up_failure",
  "home_screen_viewed",
  "navigation_tab_clicked",
  "job_row_clicked",
  "job_search_initiated",
  "create_job_button_clicked",
  "create_job_initiated",
  "job_list_scrolled",
  "job_details_viewed",
  "back_to_job_list_clicked",
  "style_sku_search_initiated",
  "edit_columns_clicked",
  "edit_column_search_initiated",
  "job_list_scroll_to_bottom",
  "job_action_menu_opened",
  "edit_column_selected",
  "edit_column_deselected",
  "edit_column_clear_clicked",
  "edit_column_apply_clicked",
  // upload screen
  "upload_screen_viewed",
  "upload_job_title_entered",
  "upload_mode_selected",
  "file_upload_clicked",
  "file_upload_success",
  "file_upload_failure",
  "upload_frequency_selected",
  "upload_schedule_dates_selected",
  "upload_submit_clicked",
  "upload_frequency_selected",
  "upload_schedule_dates_selected",
  "upload_submit_clicked",
  //export screen
  "export_screen_viewed",
  "select_job_clicked",
  "export_job_selected",
  "export_filters_clicked",
  "export_search_submitted",
  "export_filter_category_selected",
  "export_filter_option_selected",
  "export_filter_option_deselected",
  "export_filter_option_cleared",
  "export_filter_option_applied",
  //insights
  "insights_screen_viewed",
  "generate_insights_clicked",
  "view_insights_clicked",
  "insight_detail_screen_viewed",
  "insight_window_row_clicked",
  "insight_table_screen_viewed",
  "insight_export_clicked",
  "insight_view_filter_opened",
  "insight_view_selected",
  "insight_view_cleared",
  "ai_chat_opened",
  "ai_chat_closed",
] as const;
export type EventsName = (typeof EVENTS_NAME)[number];

type EventMapType = Record<
  EventsName,
  {
    [key: string]: string | number | boolean | string[];
  }
>;

type PartialEventMapType = Partial<EventMapType>;

export const EVENT_MAP: PartialEventMapType = {
  signup_started: {},
  login_screen_viewed: {},
  login_attempt: {
    email: "",
  },
  login_success: {
    email: "",
  },
  login_failure: {
    email: "",
    error_message: "",
  },
  forgot_password_clicked: {},
  sign_up_button_clicked: {},
  password_reset_initiated: {
    email: "",
  },
  password_reset_success: {
    email: "",
  },
  password_reset_failure: {
    email: "",
    error_message: "",
  },
  account_locked: {
    email: "",
    reason: "",
  },
  verification_email_sent: {
    email: "",
  },
  account_verification_completed: {
    email: "",
  },
  sign_up_failure: {
    email: "",
    error_message: "",
  },
  home_screen_viewed: {},
  navigation_tab_clicked: {
    tab_name: "",
  },
  job_row_clicked: {
    job_id: "",
    job_name: "",
  },
  job_search_initiated: {
    search_query: "",
    screen_name: "",
  },
  create_job_button_clicked: {},
  create_job_initiated: {},
  job_list_scrolled: {
    scroll_depth_percentage: 0,
  },
  job_details_viewed: {
    job_id: "",
    job_name: "",
  },
  back_to_job_list_clicked: {
    job_id: "",
  },
  style_sku_search_initiated: {},
  edit_columns_clicked: {
    job_id: "",
    screen_name: "",
  },
  edit_column_search_initiated: {
    search_query: "",
    screen_name: "",
  },
  job_list_scroll_to_bottom: {
    jobs_visible_count: 0,
    last_visible_job_id: 0,
    screen_name: "",
  },
  job_action_menu_opened: {
    job_id: 0,
    job_name: "",
    screen_name: "",
  },
  edit_column_selected: {
    column_name: "",
    selection_count: 0,
    screen_name: "",
  },
  edit_column_deselected: {
    column_name: "",
    selection_count: 0,
    screen_name: "",
  },
  edit_column_clear_clicked: {
    selection_count: 0,
    screen_name: "",
  },
  edit_column_apply_clicked: {
    final_columns_selected: [],
    screen_name: "",
  },
  upload_screen_viewed: {},
  upload_job_title_entered: {
    job_title: "",
  },
  upload_mode_selected: {
    mode: "",
  },
  file_upload_clicked: {
    upload_mode: "",
    file_format: "",
    file_size_mb: 0,
  },
  file_upload_success: {
    upload_mode: "",
    file_format: "",
    file_size_mb: 0,
  },
  file_upload_failure: {
    error_type: "",
  },
  upload_frequency_selected: {
    frequency: "",
  },
  upload_schedule_dates_selected: {
    start_date: "",
    end_date: "",
  },
  upload_submit_clicked: {
    job_title: "",
    upload_mode: "",
    file_name: "",
    frequency_value: "",
    start_date: "",
    end_date: "",
  },
  export_screen_viewed: {},
  select_job_clicked: {
    job_id: "",
    job_name: "",
  },
  export_job_selected: {
    job_id: "",
    job_name: "",
  },
  export_filters_clicked: {},
  export_search_submitted: {
    search_query: "",
  },
  export_filter_category_selected: {
    filter_category: "",
  },
  export_filter_option_selected: {
    filter_option: "",
  },
  export_filter_option_deselected: {
    filter_option: "",
  },
  export_filter_option_cleared: {
    filter_option: "",
  },
  export_filter_option_applied: {
    filter_option: "",
  },
  insights_screen_viewed: {},
  generate_insights_clicked: {
    dataset_id: "",
    dataset_name: "",
    job_id: "",
    total_style_ids: 0,
  },
  view_insights_clicked: {
    dataset_id: "",
    dataset_name: "",
    job_id: "",
  },
  insight_detail_screen_viewed: {
    dataset_id: "",
    dataset_name: "",
    total_insight_windows: 0,
  },
  insight_window_row_clicked: {
    dataset_id: "",
    dataset_name: "",
    insight_start_date: "",
    insight_end_date: "",
  },
  insight_table_screen_viewed: {
    dataset_id: "",
    dataset_name: "",
    insight_start_date: "",
    insight_end_date: "",
    total_styles_displayed: 0,
  },
  insight_export_clicked: {
    dataset_id: "",
    screen_name: "",
  },
  insight_view_filter_opened: {
    dataset_id: "",
    screen_name: "",
  },
  insight_view_selected: {
    selected_view: "",
  },
  insight_view_cleared: {},
  ai_chat_opened: {
    dataset_id: "",
    screen_name: "",
  },
  ai_chat_closed: {
    dataset_id: "",
    screen_name: "",
  },
};
